import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import WbSunnyOutlinedIcon from '@material-ui/icons/WbSunnyOutlined';
import Brightness2OutlinedIcon from '@material-ui/icons/Brightness2Outlined';
import { khonologyLightTheme, khonologyDarkTheme } from './khonologyThemes';

/** Named `light`/`dark` so they replace the built-in app themes. */
const lightTheme = ThemeBlueprint.make({
  name: 'light',
  params: {
    theme: {
      id: 'light',
      title: 'Khonology Light',
      variant: 'light',
      icon: <WbSunnyOutlinedIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={khonologyLightTheme} children={children} />
      ),
    },
  },
});

const darkTheme = ThemeBlueprint.make({
  name: 'dark',
  params: {
    theme: {
      id: 'dark',
      title: 'Khonology Dark',
      variant: 'dark',
      icon: <Brightness2OutlinedIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={khonologyDarkTheme} children={children} />
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [lightTheme, darkTheme],
});
